import * as v from "valibot";
import { rpcContract } from "../rpc";

export const startLiveEventRpcContract = rpcContract({
  name: "start-live-event",
  paramsSchema: v.object({
    event_id: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    message: v.optional(v.string()),
  }),
});

export type StartLiveEventParams = v.InferOutput<(typeof startLiveEventRpcContract)["paramsSchema"]>;
export type StartLiveEventResult = v.InferOutput<(typeof startLiveEventRpcContract)["resultSchema"]>;
